import { Component, AfterViewInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { Tablev2Component } from '../tablev2/tablev2.component';

@Component({
  selector: 'app-front-games',
  templateUrl: './front-games.component.html',
  styleUrls: ['./front-games.component.scss']
})
export class FrontGamesComponent implements AfterViewInit {
  
  public company_uuid;
  @ViewChild("table", { static: false }) tb: Tablev2Component;

  constructor(private http: HttpService, private cdr : ChangeDetectorRef) {
    this.http.getSelectedCompany().subscribe(val => {
      this.company_uuid = val;
    });
   }

   ngAfterViewInit(): void {
    this.init();
  }

  async init() {
    const setting = 
        { post: {url: "/admin/app/games/view/get", data: {uuid: this.company_uuid}},
          disabled_pagenat: true,
          fields: [
            {label: 'No', type: 'index'}, 
            {label: 'View', type: 'string', key: 'title'}, 
            {label: 'Category', type: 'string', key: 'category_title'}, 
            {label: 'Provider', type: 'string', key: 'provider'}, 
            {label: 'Game', type: 'string', key: 'game_title'}, 
            {label: 'Status', type: 'status', key: 'status'}, 
            {label: 'View', type: 'link', key: 'uuid', 'link': '/lo/' + (this.company_uuid ? '/' + this.company_uuid : '/null') + "/front/games/form", hide: true},
            {label: 'Delete', type: 'delete', key: 'uuid', table: 'setting_game_view', title: 'name', hide: true},
          ]}
      this.tb.init(setting);
      this.cdr.detectChanges();
  }

}
